import React, {Component, Fragment} from 'react';
import {Card, Form, FormFeedback, FormGroup, Input, Label} from 'reactstrap';
import withValidator from '../../models/form/withValidator';
import LoadingButton from '../../../shared/ui/LoadingButton';
import './RatingMultiFormCard.scss'
import Checkbox from "../../../shared/forms/Checkbox";

const validatorConfig = {
  cssClasses: {
    fieldInvalid: 'is-invalid',
    fieldValid: 'is-valid',
  },
  fields: {
    ratingPrompt: {
      rules: [
        {
          feedback: 'Rating prompt is required',
          test(value) {
            return !!value;
          },
        },
      ],
    },
    notResponsivePrompt: {
      rules: [],
    },
    notObservedPrompt: {
      rules: [],
    },
    minRating: {
      rules: [],
    },
    requireAckResponse: {
      rules: [],
    },
    timeSpendFieldPrompt: {
      rules: [],
    },
    useNoNr: {
      rules: []
    },
    useNotObserved: {
      rules: []
    },
    useNotResponsive: {
      rules: []
    }
  },
};

class CommentFormCard extends Component {
  constructor(props) {
    super(props);
    let scoreOverrides = sessionStorage.getItem('scoreOverrides')? JSON.parse(sessionStorage.getItem('scoreOverrides')) : {}
    this.state = {
      cssValidationClasses: {
        ratingPrompt: '' ,
        notResponsivePrompt: '' ,
        notObservedPrompt: ''
      },
      dropdownOpen: false,
      errorFeedback: {},
      isFormDisabled: true,
      ratingPrompt: !this.props.initialValues ? '' : this.props.initialValues.ratingPrompt,
      notResponsivePrompt: !this.props.initialValues ? '' : this.props.initialValues.notResponsivePrompt,
      notObservedPrompt: !this.props.initialValues ? '' : this.props.initialValues.notObservedPrompt,
      minRating: !this.props.initialValues ? '' : this.props.initialValues.minRating,
      defaultComments: !this.props.initialValues ? [] : this.props.initialValues.defaultComments || [],
      requiredComments: !this.props.initialValues ? [] : this.props.initialValues.requiredComments || [],
      hasTimeSpendField: !this.props.initialValues ? false : !!this.props.initialValues.hasTimeSpendField,
      requiredTimeSpendRatings: !this.props.initialValues ? [] : this.props.initialValues.requiredTimeSpendRatings || [],
      requireAckResponse: !this.props.initialValues ? false : !!this.props.initialValues.requireAckResponse,
      overrideDefaultScores: !this.props.initialValues ? false : !!this.props.initialValues.overrideDefaultScores,
      scoreOverrides: !this.props.initialValues ? scoreOverrides : (this.props.initialValues.scoreOverrides || scoreOverrides),
      timeSpendFieldPrompt: (!this.props.initialValues ? sessionStorage.getItem('timeSpendFieldPrompt') : (this.props.initialValues.timeSpendFieldPrompt || sessionStorage.getItem('timeSpendFieldPrompt'))),
      useNoNr: !this.props.initialValues ? false : this.props.initialValues.useNoNr,
      useNotObserved: !this.props.initialValues ? false : (this.props.initialValues.useNotObserved !== undefined ? this.props.initialValues.useNotObserved !== false : this.props.initialValues.useNoNr !== false),
      useNotResponsive: !this.props.initialValues ? false : (this.props.initialValues.useNotResponsive !== undefined ? this.props.initialValues.useNotResponsive !== false : this.props.initialValues.useNoNr !== false),
    };
  }

  // ----------------------
  // Lifecycles
  // ----------------------

  componentDidMount() {
    if (this.props.initialValues) {
      this.props.initialize({
        ratingPrompt: this.state.ratingPrompt,
        notResponsivePrompt: this.state.notResponsivePrompt,
        notObservedPrompt: this.state.notObservedPrompt,
        minRating: this.state.minRating,
        requireAckResponse: this.state.requireAckResponse,
        timeSpendFieldPrompt: this.state.timeSpendFieldPrompt,
        useNoNr: this.state.useNoNr,
        useNotObserved: this.state.useNotObserved,
        useNotResponsive: this.state.useNotResponsive
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      cssValidationClasses: nextProps.cssValidationClasses,
      errorFeedback: nextProps.errorFeedback,
      isFormDisabled: this.getIsFormInvalid(
        nextProps.hasErrors,
        nextProps.hasUntouched,
      ),
    });
  }

  // ----------------------
  // Methods
  // ----------------------

  addDefaultComment() {
    this.setState({
      defaultComments: [...this.state.defaultComments, {rating: '', comment: ''}]
    })
  }

  removeDefaultComment(index) {
    this.setState({
      defaultComments: this.state.defaultComments.filter((dfc, i) => i !== index)
    })
  }

  updateDefaultCommentRating(index, val) {
    this.setState({
      defaultComments: this.state.defaultComments.map((dfc, i) => i !== index
        ? dfc
        : {
          ...dfc,
          rating: val
        })
    })
  }

  updateDefaultCommentComment(index, val) {
    this.setState({
      defaultComments: this.state.defaultComments.map((dfc, i) => i !== index
        ? dfc
        : {
          ...dfc,
          comment: val
        })
    })
  }

  getIsFormInvalid(hasErrors, hasUntouched) {
    return hasErrors || hasUntouched;
  }

  handleBlur(event) {
    const { name, value } = event.target;
    this.props.touch(name);
    this.props.validateField(name, value, true);
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () =>
      this.props.validateField(name, value, true));

    if (name === 'timeSpendFieldPrompt') {
      sessionStorage.setItem('timeSpendFieldPrompt', value)
    }
  }

  handleSubmit() {
    const properties = {
      ratingPrompt: this.state.ratingPrompt,
      notObservedPrompt: this.state.notObservedPrompt ? this.state.notObservedPrompt : 'NO',
      notResponsivePrompt: this.state.notResponsivePrompt ? this.state.notResponsivePrompt : 'NR',
      minRating: this.state.minRating,
      defaultComments: this.state.defaultComments,
      requiredComments: this.state.requiredComments,
      hasTimeSpendField: this.state.hasTimeSpendField,
      requiredTimeSpendRatings: this.state.requiredTimeSpendRatings,
      requireAckResponse: this.state.requireAckResponse,
      timeSpendFieldPrompt: this.state.timeSpendFieldPrompt,
      overrideDefaultScores: this.state.overrideDefaultScores,
      scoreOverrides: this.state.scoreOverrides,
      useNoNr: this.state.useNoNr,
      useNotObserved: this.state.useNotObserved,
      useNotResponsive: this.state.useNotResponsive
    };

    this.props.onSave(properties);
  }

  // ----------------------
  // State setters
  // ----------------------

  toggle() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  isRequiredCommentChecked(score) {
    return !!this.state.requiredComments.find(rc => rc === score);
  }

  onRequiredCommentCheck(score, checked) {
    if (checked) {
      this.setState({
        requiredComments: [...this.state.requiredComments.filter(rc => rc !== score), score]
      })
    } else {
      this.setState({
        requiredComments: this.state.requiredComments.filter(rc => rc !== score)
      })
    }
  }

  updateNotObserved(event) {
    this.setState({useNotObserved: event.target.checked});
  }

  updateNotResponsive(event) {
    this.setState({useNotResponsive: event.target.checked});
  }

  updateTimeSpendField(val) {
    this.setState({
      hasTimeSpendField: val
    })
  }

  isRequiredTimeSpendChecked(score) {
    return !!this.state.requiredTimeSpendRatings.find(rating => rating === score);
  }

  onRequiredTimeSpendCheck(score, checked) {
    this.setState({
      requiredTimeSpendRatings: checked
        ? [...this.state.requiredTimeSpendRatings.filter(rating => rating !== score), score]
        : this.state.requiredTimeSpendRatings.filter(rating => rating !== score)
    });
  }

  updateRequireAckCommentField(val) {
    this.setState({
      requireAckResponse: val
    })
  }

  updateOverrideDefaultScoresField(val) {
    this.setState({
      overrideDefaultScores: val
    })
  }

  updateScoreOverridesField(score, val) {
    this.setState({
      scoreOverrides: {
        ...(this.state.scoreOverrides || {}),
        [score]: val
      }
    }, () => {
      sessionStorage.setItem('scoreOverrides', JSON.stringify(this.state.scoreOverrides))
    })

  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <Card className="mb-3 rating-multi-form-card">
          <Form
            className="m-3"
            noValidate
            onSubmit={event => this.handleSubmit(event)}
          >
            <FormGroup>
              <Label for="ratingPrompt">Rating prompt *</Label>
              <Input
                className={this.state.cssValidationClasses.ratingPrompt}
                id="ratingPrompt"
                name="ratingPrompt"
                onBlur={event => this.handleBlur(event)}
                onChange={event => this.handleInput(event)}
                placeholder="Header"
                type="textarea"
                rows={2}
                value={this.state.ratingPrompt}
              />
              <FormFeedback>{this.state.errorFeedback.ratingPrompt}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Checkbox checked={this.state.useNotObserved} label="Use Not Observed field?"
                        onChange={event => this.updateNotObserved(event)}/>
            </FormGroup>

            {this.state.useNotObserved && (
              <Fragment>
                <FormGroup>
                  <Label for="notObservedPrompt">Not observed prompt *</Label>
                  <Input
                    className={this.state.cssValidationClasses.notObservedPrompt}
                    id="notObservedPrompt"
                    name="notObservedPrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Header"
                    value={this.state.notObservedPrompt}
                  />
                  <FormFeedback>{this.state.errorFeedback.notObservedPrompt}</FormFeedback>
                </FormGroup>
              </Fragment>
            )}

            <FormGroup>
              <Checkbox checked={this.state.useNotResponsive} label="Use Not Responsive field?"
                        onChange={event => this.updateNotResponsive(event)}/>
            </FormGroup>

            {this.state.useNotResponsive && (
              <Fragment>
                <FormGroup>
                  <Label for="notResponsivePrompt">Not responsive prompt *</Label>
                  <Input
                    className={this.state.cssValidationClasses.notResponsivePrompt}
                    id="notResponsivePrompt"
                    name="notResponsivePrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Header"
                    value={this.state.notResponsivePrompt}
                  />
                  <FormFeedback>{this.state.errorFeedback.notResponsivePrompt}</FormFeedback>
                </FormGroup>
              </Fragment>
            )}

            {/*<FormGroup>*/}
            {/*  <Label for="minRating">Min rating</Label>*/}
            {/*  <Input*/}
            {/*    className={this.state.cssValidationClasses.minRating}*/}
            {/*    type="number"*/}
            {/*    id="minRating"*/}
            {/*    name="minRating"*/}
            {/*    onBlur={event => this.handleBlur(event)}*/}
            {/*    onChange={event => this.handleInput(event)}*/}
            {/*    placeholder="Min rating"*/}
            {/*    value={this.state.minRating}*/}
            {/*  />*/}
            {/*  <FormFeedback>{this.state.errorFeedback.minRating}</FormFeedback>*/}
            {/*</FormGroup>*/}

            <div className="rating-multi-default-comments">
              <label>Default comments for rating</label>
              {this.state.defaultComments.map((dfc, index) => (
                <FormGroup className="default-comments-item" key={index}>
                  <select className="form-control" value={dfc.rating} onChange={(e) => this.updateDefaultCommentRating(index, e.target.value)}>
                    <option defaultValue>Select rating</option>
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                    <option value={6}>6</option>
                    <option value={7}>7</option>
                  </select>
                  <Input type="textarea" placeholder="Enter default comment" value={dfc.comment} onChange={e => this.updateDefaultCommentComment(index, e.target.value)}/>
                  <button type="button" className="button small danger" onClick={() => this.removeDefaultComment(index)}>
                    <i className="fa fa-close"/>
                  </button>
                </FormGroup>
              ))}
              <div className="text-right">
                <button type="button" className="button small secondary" onClick={() => this.addDefaultComment()}>
                  <i className="fa fa-plus"/>
                  <span>Add comment for rating</span>
                </button>
              </div>
            </div>
            <div className="rating-multi-required-comments mb-3">
              <label>Select scores that that have required comment</label>
              <div className="row">
                <div className="col">
                  <Checkbox
                    label="1"
                    checked={this.isRequiredCommentChecked(1)}
                    onChange={e => this.onRequiredCommentCheck(1, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="2"
                    checked={this.isRequiredCommentChecked(2)}
                    onChange={e => this.onRequiredCommentCheck(2, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="3"
                    checked={this.isRequiredCommentChecked(3)}
                    onChange={e => this.onRequiredCommentCheck(3, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="4"
                    checked={this.isRequiredCommentChecked(4)}
                    onChange={e => this.onRequiredCommentCheck(4, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="5"
                    checked={this.isRequiredCommentChecked(5)}
                    onChange={e => this.onRequiredCommentCheck(5, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="6"
                    checked={this.isRequiredCommentChecked(6)}
                    onChange={e => this.onRequiredCommentCheck(6, e.target.checked)}
                  />
                </div>
                <div className="col">
                  <Checkbox
                    label="7"
                    checked={this.isRequiredCommentChecked(7)}
                    onChange={e => this.onRequiredCommentCheck(7, e.target.checked)}
                  />
                </div>
              </div>
            </div>
            <div className="mb-4">
              <Checkbox
                label="Has time spend field"
                checked={this.state.hasTimeSpendField}
                onChange={e => this.updateTimeSpendField(e.target.checked)}
              />
            </div>
            {this.state.hasTimeSpendField && (
              <div className="mb-4">
                <FormGroup>
                  <Label for="timeSpendFieldPrompt">Time spend field prompt</Label>
                  <Input
                    id="timeSpendFieldPrompt"
                    name="timeSpendFieldPrompt"
                    onBlur={event => this.handleBlur(event)}
                    onChange={event => this.handleInput(event)}
                    placeholder="Time spend field prompt"
                    value={this.state.timeSpendFieldPrompt}
                  />
                </FormGroup>
                <div className="rating-multi-required-comments">
                  <label>Select scores that require time spent</label>
                  <div className="row">
                    {[1, 2, 3, 4, 5, 6, 7].map(score => (
                      <div className="col" key={score}>
                        <Checkbox
                          label={score.toString()}
                          checked={this.isRequiredTimeSpendChecked(score)}
                          onChange={e => this.onRequiredTimeSpendCheck(score, e.target.checked)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <div className="mb-4">
              <Checkbox
                label="Require acknowledge comment"
                checked={this.state.requireAckResponse}
                onChange={e => this.updateRequireAckCommentField(e.target.checked)}
              />
            </div>
            <div className="mb-4">
              <Checkbox
                label="Override default scores"
                checked={this.state.overrideDefaultScores}
                onChange={e => this.updateOverrideDefaultScoresField(e.target.checked)}
              />
            </div>
            { this.state.overrideDefaultScores &&
              <div className="mb-4">
                <div>Enter the text that will match each rating</div>
                <FormGroup>
                  <Label for="ratingOverride1">(1)</Label>
                  <Input
                    id="ratingOverride1"
                    name="ratingOverride1"
                    onChange={event => this.updateScoreOverridesField(1, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[1]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride2">(2)</Label>
                  <Input
                    id="ratingOverride2"
                    name="ratingOverride2"
                    onChange={event => this.updateScoreOverridesField(2, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[2]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride3">(3)</Label>
                  <Input
                    id="ratingOverride3"
                    name="ratingOverride3"
                    onChange={event => this.updateScoreOverridesField(3, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[3]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride4">(4)</Label>
                  <Input
                    id="ratingOverride4"
                    name="ratingOverride4"
                    onChange={event => this.updateScoreOverridesField(4, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[4]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride5">(5)</Label>
                  <Input
                    id="ratingOverride5"
                    name="ratingOverride5"
                    onChange={event => this.updateScoreOverridesField(5, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[5]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride6">(6)</Label>
                  <Input
                    id="ratingOverride6"
                    name="ratingOverride6"
                    onChange={event => this.updateScoreOverridesField(6, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[6]}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="ratingOverride7">(7)</Label>
                  <Input
                    id="ratingOverride7"
                    name="ratingOverride7"
                    onChange={event => this.updateScoreOverridesField(7, event.target.value)}
                    placeholder="Time spend field prompt"
                    value={this.state.scoreOverrides[7]}
                  />
                </FormGroup>
              </div>
            }
            <div>
              <LoadingButton
                primary
                text="Save"
                isLoading={this.props.isLoading}
                disabled={this.state.isFormDisabled}
                onClick={event => this.handleSubmit(event)}
              />
            </div>
          </Form>
        </Card>
      </Fragment>
    );
  }
}

export default withValidator(CommentFormCard, validatorConfig);
